import { render, staticRenderFns } from "./ProfileStatisticView.vue?vue&type=template&id=5f7a016e&scoped=true&"
import script from "./ProfileStatisticView.vue?vue&type=script&lang=ts&"
export * from "./ProfileStatisticView.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileStatisticView.vue?vue&type=style&index=0&id=5f7a016e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a016e",
  null
  
)

export default component.exports